import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ApiError } from '../entities/api-error.entity';
import { InternalError } from '../entities/internal-error.entity';
import { ErrorService } from '../services/error.service';
import { SKIP_ERROR_TOAST } from './skip-error-toast.token';

const HTTP_ERROR_KEYS: Record<number, string> = {
  400: 'common.error.http.400',
  401: 'common.error.http.401',
  403: 'common.error.http.403',
  404: 'common.error.http.404',
  408: 'common.error.http.408',
  409: 'common.error.http.409',
  429: 'common.error.http.429',
  500: 'common.error.http.500',
  502: 'common.error.http.502',
  503: 'common.error.http.503',
  504: 'common.error.http.504',
};

const SILENT_STATUSES = new Set([401]);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(ErrorService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const errorMessage =
        HTTP_ERROR_KEYS[error.status] ??
        'common.error.http.unknown';

      const traceId: string =
        error.error?.result?.traceId ??
        error.headers?.get('x-trace-id') ??
        '';

      const internalErrors: InternalError[] = Array.isArray(error.error?.result?.errors)
        ? error.error.result.errors.map((err: { code: number; message: string }) => ({
            code: err.code,
            message: err.message,
          }))
        : [];

      if (!environment.production) {
        console.error('HTTP Error:', error);
      }

      const apiError: ApiError = {
        generalErrorMessage: errorMessage,
        internalErrors,
        traceId,
        originalError: error,
      };

      const skipToast =
        req.context.get(SKIP_ERROR_TOAST) || SILENT_STATUSES.has(error.status);

      if (!skipToast) {
        errorService.showApiError(apiError);
      }

      return throwError(() => apiError);
    }),
  );
};
